import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {forkJoin} from 'rxjs';
import {ControlContainer, NgForm} from '@angular/forms';
import {ClassificatorValueQuery} from 'common-shared';
import {UnitQuery} from 'common-shared';
import {PropertyQuery} from 'common-shared';
import {PropertyLineModel} from '../../../properties/models/property-line.model';
import {ClassificatorValuesQuery} from 'common-shared';
import {PropertyService} from '../../../properties/property.service';
import {UnitService} from '../../units/unit.service';
import {GLOBAL} from 'common-shared';
import {map} from 'rxjs/operators';

@Component({
  selector: 'mes-web-property-line-edit',
  templateUrl: './property-line-edit.component.html',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class PropertyLineEditComponent implements OnInit, OnChanges {
  choices: ClassificatorValueQuery[] = [];
  @Input() propertyId: string;

  units: UnitQuery[] = [];
  private properties: PropertyQuery[] = [];
  private clValues: ClassificatorValueQuery[] = [];
  @Input()
  readOnly: boolean;
  @Input()
  propertyLine: PropertyLineModel;
  @Input()
  defaultLine: PropertyLineModel = new PropertyLineModel();
  @Input()
  constraints: any[] = [];

  @Output() lineChanged = new EventEmitter<{ $value: any, $propertyLine: PropertyLineModel }>();
  parsedConstraints: { Id: any; Value: any }[];

  constructor(public classificatorValueService: ClassificatorValuesQuery, private unitService: UnitService, private propertyService: PropertyService) {
  }

  ngOnInit() {
    forkJoin(
      this.unitService.query.selectAll().pipe(map((result) => {
        return this.units = result;
      })),
      this.propertyService.getAll$.pipe(map((result) => {
        this.properties = result;
      })),
      this.classificatorValueService.getAll$.pipe(map((result) => {
        return this.clValues = result;
      }))
    ).subscribe(value => {
        this.updateChoices();
        if (this.constraints) {
          if (this.getProperty().TypeClv === GLOBAL.Classificators.PropertyType.Numeric || this.getProperty().TypeClv === GLOBAL.Classificators.PropertyType.Text) {
            this.parsedConstraints = this.constraints.map((c) => {
              return {Id: c, Value: c};
            });
          }
          if (this.getProperty().TypeClv === GLOBAL.Classificators.PropertyType.Choice) {
            const choices = this.choices;
            this.parsedConstraints = this.constraints.map((c) => {
              return choices.find(ch => ch.Id === c);
            });
          }
        }
      });
    this.getProperty();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.propertyId) {
      this.updateChoices();
    }
  }

  getProperty() {
    return this.properties.find((p) => {
      return p.Id === this.propertyId;
    });
  }

  getChoiceValue(clvId: string) {
    const choices = this.choices;
    if (!(choices || []).length) {
      return '';
    }
    return (choices.find((c) => {
      return c.Id === clvId;
    }) || {Value: ''}).Value;
  }

  updateChoices() {
    const property = this.getProperty();
    if (property && property.TypeClv === GLOBAL.Classificators.PropertyType.Choice) {
      const filtered = this.clValues.filter(value => value.ClassificatorId === property.ChoiceTypeClassificatorId);
      this.choices = filtered.sort((choice, b) => {
        return (choice.IsDefault === true ? '.' : choice.Value).localeCompare(b.IsDefault === true ? '.' : b.Value);
      });
    }
    if (this.getProperty() && this.getProperty().ChoiceTypeClassificatorId) {
      if (this.choices.length && this.propertyLine.ValueClv === undefined) {
        if (this.choices[0].IsDefault) {
          this.propertyLine.ValueClv = this.choices[0].Id;
          this.onDefaultValueChanged(this.propertyLine.ValueClv);
        }
      }
    }
  }

  onDefaultValueChanged(value) {
    this.lineChanged.emit({$value: value, $propertyLine: this.propertyLine});
  }

  isPropertyNumeric() {
    return this.getProperty().TypeClv === GLOBAL.Classificators.PropertyType.Numeric;
  }

  isPropertyText() {
    return this.getProperty().TypeClv === GLOBAL.Classificators.PropertyType.Text;
  }

  isPropertyChoice() {
    return this.getProperty().TypeClv === GLOBAL.Classificators.PropertyType.Choice;
  }

  isPropertyHtml() {
    return this.getProperty().TypeClv === GLOBAL.Classificators.PropertyType.Html;
  }

  isPropertyDateTime() {
    return this.getProperty().TypeClv === GLOBAL.Classificators.PropertyType.DateTime;
  }

  getUnit() {
    return (this.units.find(value => value.Id === this.getProperty().UnitId) || new UnitQuery()).Code;
  }


}
